import { cn } from '@/lib/utils'

interface MegaphoneIconProps {
  className?: string
}

/**
 * Megaphone, using Lucide's current drawing rather than the one bundled with
 * our pinned `lucide-react` (0.344.0, early 2024). Lucide redrew this glyph
 * since: the old path is a thin diagonal wedge only 3 units tall at its tip,
 * which collapses into an unreadable sliver at the 16px we render it at. The
 * current drawing is a horizontal megaphone with an 8-unit body and a flared
 * bell, so it survives being small.
 *
 * Delete this file and import `Megaphone` from lucide-react once the dependency
 * is upgraded (that upgrade redraws icons across ~237 files, so it needs its own
 * visual QA pass — it is not a side effect of this component).
 */
export function MegaphoneIcon({ className }: MegaphoneIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('h-4 w-4', className)}
      aria-hidden="true"
    >
      <path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
      <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" />
      <path d="M8 6v8" />
    </svg>
  )
}
